import { Button } from "@/components/button";
import { FONT } from "@/styles/common";
import { Center, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomCenter = styled(Center)`
    height: 72px;
    justify-content: flex-end;
    background: ${({ theme }) => theme.COLOR.white};
    box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.1);
`;

export const CustomText = styled(Text)`
    ${FONT("pretendard", 16, 500)}

    & span {
        ${FONT("pretendard", 24, 700)}
        color: ${({ theme }) => theme.COLOR.button[200]}
    }
`;

export const CustomButton = styled(Button)`
    ${FONT("pretendard", 16, 700)}
    color: ${({ theme }) => theme.COLOR.button[200]};
    border: 1px solid ${({ theme }) => theme.COLOR.button[200]};

    &:hover {
        color: ${({ theme }) => theme.COLOR.white};
        background: ${({ theme }) => theme.COLOR.button[200]};
        border: none;
    }
`;
